import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import {
    DataPointMappingHeaderLayout,
    DataPointMappingHeaderTitle,
    DataPointMappingHeaderUnion,
} from './data-point-mapping-header.style';

interface DataPointMappingHeaderComponentProps {
    pocMappingHeader: string;
    ldapMappingHeader: string;
}

export const DataPointMappingHeaderComponent: React.FC<DataPointMappingHeaderComponentProps> = (props) => {
    const { pocMappingHeader, ldapMappingHeader } = props;

    return (
        <DataPointMappingHeaderLayout>
            <DataPointMappingHeaderTitle>
                <PocTypography element="h6" variant="subtitle2" style={{ flex: '1 1 auto' }}>
                    {pocMappingHeader}
                </PocTypography>
            </DataPointMappingHeaderTitle>
            <DataPointMappingHeaderUnion />
            <DataPointMappingHeaderTitle>
                <PocTypography element="h6" variant="subtitle2" style={{ flex: '1 1 auto' }}>
                    {ldapMappingHeader}
                </PocTypography>
            </DataPointMappingHeaderTitle>
        </DataPointMappingHeaderLayout>
    );
};
